import { createClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

export const supabase = createClient(supabaseUrl, supabaseAnonKey)

// Cached user role to avoid repeated DB queries
let cachedUserRole = null

export async function getUserRole() {
  if (cachedUserRole) return cachedUserRole
  
  const { data: { user } } = await supabase.auth.getUser()
  if (!user) return null
  
  const { data: profile } = await supabase
    .from('user_profile')
    .select('role')
    .eq('id', user.id)
    .single()
  
  cachedUserRole = profile?.role || 'viewer'
  return cachedUserRole
}

export function clearUserRoleCache() {
  cachedUserRole = null
}
